import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'dayjsFormat',
  standalone: true
})
export class DayjsFormatPipe implements PipeTransform {

  public transform(value: dayjs.Dayjs, format = ''): string {
    return value.format(format);
  }
}
